<template>
  <div>

    <div class="row form-group mt-1">

      <AppPaging
        v-show="tablePaging && tableData && tableData.length > 0" 
        ref="tablePaging"
        class="col"
        v-on:paging-data-change="onTablePageChange" />
      
    </div>

    <TemplateFeedback ref="tableFeedback" />

    <TemplateAlert 
      v-show="tableData && tableData.length === 0"
      v-bind:message="tableEmptyMessage || 'No data available.'"
      v-bind:class="'alert-warning'" />
    
    <div 
      v-show="tableData && tableData.length > 0" 
      class="col-12 table-responsive">

      <table 
        v-bind="{id: 'jt-table' + (tableIdSuffix || '')}"
        class="table table-bordered">

        <tr>
          
          <th 
            v-for="tableParameterItem in tableParameter" 
            v-bind:key="tableParameterItem.key" 
            v-show="renderTableCellShow(tableParameterItem)" >

            <span
              v-html="renderTableHeader(tableParameterItem)"/>

            <slot 
              v-bind:name="'jt-table-th-slot-' + tableParameterItem.key" />

          </th>

        </tr>

        <tr 
          v-for="(tableDataItem, tableDataIndex) in tableData"
          v-bind:key="tableDataItem[getTableIdentifier()]" >

          <td 
            v-for="(tableParameterItem, tableParameterIndex) in tableParameter" 
            v-bind:key="tableParameterItem.key" 
            v-bind:rowspan="getTableRowSpan(tableData, tableDataIndex, tableParameter, tableParameterIndex)"
            v-show="getTableRowSpan(tableData, tableDataIndex, tableParameter, tableParameterIndex) && renderTableCellShow(tableParameterItem)">

            <component 
              href="#"
              v-bind:is="renderTablePopup(tableParameterItem.table_popup)"
              @click="tableParameterItem.table_popup ? onTableAnchorClick($event, tableData, tableDataIndex, tableParameter, tableParameterIndex) : null">
              <AppTableCell 
                v-bind:tableData="tableData" 
                v-bind:tableDataIndex="tableDataIndex" 
                v-bind:tableParameter="tableParameter" 
                v-bind:tableParameterIndex="tableParameterIndex"
                v-bind:tablePage="tablePage"
                v-on:table-cell-click="onTableCellClick"
                v-on:table-cell-input="onTableCellInput"
                v-on:table-cell-change="onTableCellChange"
                v-on:table-cell-custom="onTableCellCustom" />
            </component>
            
          </td>
        </tr>
        
      </table>

    </div>

  </div>
</template>

<script>
import AppPaging from "@/components/App/AppPaging";
import AppTableCell from "@/components/App/AppTableCell";
import TemplateAlert from "@/components/Template/TemplateAlert";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import helper from "@/components/Utility/Helper"

export default {
  name: "AppTable",
  props: ['tableParameter', 'tableEmptyMessage', 'tableIdSuffix'],
  components: {
    AppPaging,
    AppTableCell,
    TemplateAlert,
    TemplateFeedback,
  },
  mounted() {
    if(window.location.href.includes('localhost')) {
      let cheat = 'createDate';
      let cheatx = 'createDatexxx';
      if(!this.tableParameter.some(k => k.key === cheatx)) {
        this.tableParameter.push({
          key: cheatx,
          text: 'KW DATE',
          table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
            let parameterItem = dataParameter[parameterIndex];
            let dataItem = dataResult[dataIndex];
            return helper.formatDateTime(dataItem[cheat])
          },
          form_hide: true,
          form_add_hide: true,
          form_edit_hide: true,
          form_input_validation: [],
        })
      }

      let cheat2 = 'id';
      let cheatx2 = 'idxxx';
      if(!this.tableParameter.some(k => k.key === cheatx2)) {
        this.tableParameter.push({
          key: cheatx2,
          text: 'KW ID',
          table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
            let parameterItem = dataParameter[parameterIndex];
            let dataItem = dataResult[dataIndex];
            return dataItem[cheat2]
          },
          form_hide: true,
          form_add_hide: true,
          form_edit_hide: true,
          form_input_validation: [],
        })
      }
    }
  },
  data() {
    return {
      tablePaging: true,
      tableData: null,
      tablePage: 1,
    };
  },
  methods: {
    getTableIdentifier() {
      return 'id';
    },
    setTableLoading(message) {
      this.$refs['tableFeedback'].setFeedbackLoading(message);
      this.tableData = null;
    },
    setTableError(error) {
      this.$refs['tableFeedback'].setFeedbackError(error);
      this.tableData = null;
    },
    setTablePaging(show) {
      this.tablePaging = show;
    },
    setTableData(data, page) {
      this.$refs['tableFeedback'].setFeedbackMessage(null);
      this.tableData = data;
      this.tablePage = page || this.getCurrentPage() || 1;
    },

    setTotalPage(page, count) {
      this.$refs['tablePaging'].setTotalPage(page, count);
    },
    setCurrentPage(page) {
      this.$refs['tablePaging'].setCurrentPage(page);
    },
    getCurrentPage() {
      return this.$refs['tablePaging'].currentPage;
    },

    getTableRowSpan(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      return 1;
    },

    renderTableCellShow: function (tableParameterItem) {
      if(tableParameterItem.id || tableParameterItem.form_section || tableParameterItem.form_div || tableParameterItem.table_hide) {
        return false;
      }

      return true
    },
    renderTablePopup: function(table_popup) {
      if(typeof table_popup === 'string') {
        return table_popup;
      } else {
        if(table_popup) {
          return 'a';
        } else {
          return 'div';
        }
      }
    },
    renderTableHeader: function(tableParameterItem) {
      if(tableParameterItem.index) {
        return tableParameterItem.index.key || tableParameterItem.index.text || 'No.';
      }

      if(tableParameterItem.table_head) {
        return tableParameterItem.table_head;
      } else if(tableParameterItem.text) {
        if(tableParameterItem.text.endsWith('*')) {
          return tableParameterItem.text.substring(0, tableParameterItem.text.length - 1);
        } else {
          return tableParameterItem.text;
        }
      } else {
        return tableParameterItem.key;
      }
    },

    onTableAnchorClick(e, tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      e.preventDefault();
      this.$emit('table-data-click', tableData, tableDataIndex, tableParameter, tableParameterIndex);
    },
    onTableCellClick(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      this.$emit('table-cell-click', tableData, tableDataIndex, tableParameter, tableParameterIndex);
    },
    onTableCellInput(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      this.$emit('table-cell-input', tableData, tableDataIndex, tableParameter, tableParameterIndex);
    },
    onTableCellChange(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      this.$emit('table-cell-change', tableData, tableDataIndex, tableParameter, tableParameterIndex);
    },
    onTableCellCustom(...args) {
      this.$emit('table-cell-custom', ...args);
    },
    onTablePageChange(page) {
      this.$emit('table-page-change', page);
    },
  },
};

</script>


// WEBPACK FOOTER //
// src/components/App/AppTable.vue